import './App.css';
import './SortingVisulaiser/SortingVisualiser'
import SortingVisualiser from './SortingVisulaiser/SortingVisualiser';
function App() {
  return (
    <div >
      <SortingVisualiser/>
    </div>
  );
}

export default App;
